function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFAF20",
  fillRule: "nonzero",
  d: "M10.479.843a5.666 5.666 0 0 1 2.51 10.745l-.217.102.369.072c1.464.311 2.782.881 3.86 1.678l.265.203.23.192c1.654 1.43 2.56 3.382 2.636 5.668l.005.314v.342H.82v-.342c0-2.526.995-4.664 2.873-6.174 1.212-.973 2.759-1.642 4.492-1.953A5.667 5.667 0 0 1 10.48.843zm.003 11.33c-2.495 0-4.753.713-6.36 2.004-1.627 1.309-2.525 3.132-2.61 5.297H19.45c-.085-2.167-.983-3.99-2.61-5.297-1.608-1.291-3.865-2.004-6.36-2.004zM8.572 1.904a4.982 4.982 0 0 0-3.074 4.603l.005.216a4.982 4.982 0 1 0 3.07-4.819z"
});

var SvgPersonIcon = function SvgPersonIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    style: {
      background: "#fff"
    },
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person_icon.973d48b8.svg";
export { ForwardRef as ReactComponent };